import { Creative } from 'lib.store/src/type-organizer/creatives/models';

export const findNextCreative = (creatives: Creative[], selectedCreative: Creative) => {
  const currentIndex = creatives.findIndex(
    (creative) => creative.id.toString() === selectedCreative.id.toString(),
  );

  // Look for next creative with status.id === '1' starting from current position
  for (let i = currentIndex + 1; i < creatives.length; i++) {
    if (creatives[i].status.id.toString() === '1') {
      return creatives[i];
    }
  }

  // If not found after current position, look from beginning up to current position
  for (let i = 0; i < currentIndex; i++) {
    if (creatives[i].status.id.toString() === '1') {
      return creatives[i];
    }
  }

  // If no creative with status '1' found, return null
  return null;
};
